class GameDataStore extends SlotGame.src.store.GameData {

}

export {GameDataStore};

SlotGame.src.store.GameData = GameDataStore;